export default function moveModalsToEnd() {
	const modals = document.querySelectorAll('.modal');
	const body = document.querySelector('body');

	modals.forEach(function (modal) {
		body.appendChild(modal);
	});
}
